module.exports = __webpack_public_path__ + "static/media/ompanyid4.8344f69e.png";